import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { StockTransferPopup } from './StockTransferTable';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import moment from 'moment';
import TransactionStockServices from '../../../services/axiosServices/apiServices/TransactionStockServices';
import { EditStockTransferItem } from './EditStockTransferItem';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class StockTransfer extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.transactionStockServices = new TransactionStockServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isModalOpenForEditItem: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            table2Data: [],
            table2ColDefs: [],
            firstList: [],
            secondList: [],
            tempSecondList: [],
            open: false,
            stockObject: {
                idStockTransfer: 0,
                updateStatus: 0,
                idWOOrderRecv: 0,
                idSalesInvoice: 0,
                transferNo: '',
                prefix: "",
                transferDate: '',
                orderNo: "",
                idPartyAccount: 0,
                idTransfer: 0,
                transferList: [],
                vehicleNo: '',
                address: '',
                ordDate: '',
                Transporter: '',
                totalArticals: '',
                totalQuantity: '',
                //totalQty: 0,
                e_Date: "",
                idFinancialYear: 0,
            },
            itemObject: {
                //woRecvNo: x.woRecvNo,
                //drawingNo: item.drawingNo,
                //itemType: item.itemType,
                //idItem: item.idItem,
                //itemDetails: item.itemName,
                keyId: 0,
                woQuantity: 0,
                quantity: 0,
                remarks: "",
                avlStock: 0,
                rate: 0,
                amount: 0,
                //idwoOrderRecvItems: item.idwoOrderRecvItems,
                //idwoOrderRecv: item.idwoOrderRecv,
                displaySerialNo: "",
            },
            itemRowData: [],
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                product: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                idTaxStructure: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            },
        }
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetailsFields();
        this.setState({ isModalOpen: true, open: false }, () => {
            this.getPrefixSelectPrefix();
        })
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTransactionStockTransferSelectbyId(event.data.idStockTransfer);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.stockObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    closePopup = () => {
        this.setState({ isModalOpen: false, });
    };

    handleChange = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.stockObject;
        // if (name === "assembly") {
        //     details.assembly = !details.assembly
        // } else {
        details[name] = value;
        // }
        this.setState({ stockObject: details });
    }

    resetDetailsFields = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let obj = this.state.stockObject;
        obj.idStockTransfer = 0;
        obj.updateStatus = 0;
        obj.idWOOrderRecv = 0;
        obj.idSalesInvoice = 0;
        obj.transferNo = '';
        obj.prefix = "";
        obj.transferDate = '';
        obj.orderNo = "";
        obj.idPartyAccount = 0;
        obj.idTransfer = 0;
        //obj.transferList = [];
        obj.vehicleNo = '';
        obj.address = '';
        obj.ordDate = '';
        obj.Transporter = '';
        obj.totalArticals = '';
        obj.totalQuantity = ''
        this.setState({
            validState: validState, stockObject: obj, itemRowData: []
        });
    }

    handleChangeForDropdown = (event, name) => {
        let details = this.state.stockObject;
        let value = event.value;
        // if (name === 'rateOn' || name === 'itemType') {
        //     details[name] = event.label;
        // } else {
        details[name] = value;
        //}
        this.setState({ stockObject: details }, () => {
            if (name === 'idTransfer') {
                this.getPartyAccountSelectbyID()
            }
            //else if (name === 'idProduct') {
            //     this.getMasterProductSelectForProductionStock2()
            // }
        });
    }

    handleCellClickfirstList = (event) => {
        // if (event.data.idPurchaseInquiry > 0 && this.state.purchaseObject.idVendor > 0) {
        //     this.getPurchaseInquirySelectbyIDNotInPurchaseOrder(event.data.idPurchaseInquiry);
        // } else if (event.data.idPurchaseInquiry > 0) {
        //     this.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2(event.data.idPurchaseInquiry);
        // }
        this.filterVendorRowData(event.data.idwoOrderRecv)
    };

    handleCellClickItemList = (event) => {
        this.resetItemObject();
        this.setState({ isModalOpenForEditItem: true }, () => {
            let data = this.state.itemObject;
            data.keyId = event.data.keyId;
            data.woQuantity = event.data.woQuantity;
            data.quantity = event.data.quantity;
            data.remarks = event.data.remarks;
            data.avlStock = event.data.avlStock;
            data.rate = event.data.rate;
            data.amount = event.data.amount;
            data.displaySerialNo = event.data.displaySerialNo;
            this.setState({ itemObject: data });
        });
    };

    onSelectionChanged = (selectedRows) => {
        this.setState({ selectedRowsForfirstList: selectedRows });
    };

    setOpenModelForItem = () => {
        this.setState({ isModalOpenForEditItem: !this.state.isModalOpenForEditItem });
    };

    handleChangeForChequeBookItem = (event, name) => {
        let value = event.target.value;
        let details = this.state.itemObject;
        if (name === 'quantity') {
            if (details.woQuantity >= value) {
                details.quantity = value;
            } else if (details.woQuantity < value) {
                details.quantity = details.woQuantity
            }
        } else {
            details[name] = value;
        }
        this.setState({ itemObject: details }, () => {
            this.rowCalculation();
        });
    }

    rowCalculation = () => {
        let data = this.state.itemObject
        if (data.quantity > 0 && data.quantity > 0) {
            data.amount = Number(data.quantity) * Number(data.rate);
        } else {
            data.amount = 0;
        }
        this.setState({ itemObject: data });
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.getPrefixSelectPrefix();
                //this.getAllDropdownAndCountsForOtherForms();
            });
        }
    }

    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionStockTransfer",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.stockObject;
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ stockObject: dt }, () => {
                    this.getAllDropdownAndCountsForOtherForms();
                });
            } else {
                this.getAllDropdownAndCountsForOtherForms();
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Stock Transfer",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {

                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idStockTransfer"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Stock Transfer",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id);
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    getColumnWidth = (key) => {
        const colwidth = {
            // "sR.No": window.innerWidth * 0.04,
            // "challanNo": window.innerWidth * 0.04,
            // "challandate": window.innerWidth * 0.06,
            // "vendor": window.innerWidth * 0.29,
            // "invoiceNo": window.innerWidth * 0.04,
            // "invoiceDate": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }

    procSelectAllRecord2GridviewSP = (id) => {
        //debugger;
        let request = {
            id: id,
            formname: "Stock Transfer",
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode == 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.table2ColWidth(key),
                            pinned: this.table2PinnedWidth(key) ? "left" : null,
                            width: this.table2ColWidth(key),
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    table2ColWidth = (key) => {
        const colWidth = {

            // "quantity": window.innerWidth * 0.06,
            // "rate": window.innerWidth * 0.06,
            // "taxableAmt": window.innerWidth * 0.06,
            // "sgst": window.innerWidth * 0.05,
            // "sgstAmt": window.innerWidth * 0.06,
            // "cgst": window.innerWidth * 0.05,
            // "cgstAmt": window.innerWidth * 0.06,
            // "igst": window.innerWidth * 0.05,
            // "igstAmt": window.innerWidth * 0.06,
            // "netTotal": window.innerWidth * 0.08,
            // "isVariation": window.innerWidth * 0.06,
        }
        return colWidth[key];
    }

    table2PinnedWidth = (key) => {
        const pinnedWidths = {
            // "drawingNo": window.innerWidth * 0.1,
            // "itemCategory": window.innerWidth * 0.15,
            // "itemName": window.innerWidth * 0.15,
        }
        return pinnedWidths[key];
    }

    getAllDropdownAndCountsForOtherForms = () => {
        let request = [this.state.idCompany, 0];
        this.otherFormsServices.getAllDropdownAndCountsForOtherForms(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let allData = response.responseItem.responseContent;
                let data = this.state.stockObject;
                let dAssNo = allData.filter(item => item.source === 'StockTransfer')?.[0].value;
                let master_Party = allData.filter(item => item.source === 'Master_PartyAccountForStockTransfer');
                let maxIdPaymentMake = dAssNo > 0 ? dAssNo : 0;
                let receiptNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                data.transferNo = data.prefix + receiptNo;
                data.transferList = master_Party;
                this.setState({
                    stockObject: data
                });
            } else {
                //this.usp_Master_EmployeeSelect()
            }
        });
    }

    getPartyAccountSelectbyID = () => {
        if (this.state.stockObject.idTransfer > 0) {
            this.accountTransactionServices.getPartyAccountSelectbyID(this.state.stockObject.idTransfer).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.stockObject;
                    //data.modeOfPayment = res.paymentTerms;
                    data.address = res.p_Address;
                    data.idPartyAccount = res.idPartyAccount;
                    //data.email = res.emailID; //  data.inwardType?.find(item => item.name === res.invoiceType)?.id;
                    this.setState({ stockObject: data }, () => {
                        //this.getMasterItemSelectbyItemTypeVendorwise();
                    });
                }
            });
        }
    }

    addWorkOrder = () => {
        if (this.state.stockObject.idPartyAccount > 0) {
            let request = {
                idCompany: this.state.idCompany,
                updateStatus: this.state.stockObject.updateStatus,
                idSalesInvoice: this.state.stockObject.idSalesInvoice,
                idVendor: this.state.stockObject.idPartyAccount
            }
            this.transactionStockServices.getWorkOrderSalesInvoiceByVendorIdforTaxInvoice(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent.workOrderRecvs;
                    dynamicData.map(x => {
                        x.selectedRows = false;
                        x.refNo = x.woRecvNo;
                        x.woRecvDate = x.woRecvDate ? moment(x.woRecvDate).format('DD-MM-YYYY') : '';
                        // if (x.idwoOrderRecv === 1016) {
                        //     x.selectedRows = true;
                        // }
                    });
                    let dynamicDataForItem = response.responseItem.responseContent.details;
                    dynamicDataForItem.map(x => {
                        x.id = x.idwoOrderRecv;
                        x.itemId = x.idwoOrderRecvItems;
                    });
                    this.setState({
                        firstList: dynamicData,
                        tempSecondList: dynamicDataForItem,
                        open: true
                    }, () => {
                        this.filterVendorRowData(this.state.tempSecondList[0]?.idwoOrderRecv)
                    });
                }
            })

            //this.setState({ open: true });
        } else {
            this.SwalServices.Alert('Please select customer first')
        }
    }

    addProduct = () => {
        this.setState({ open: true }, () => {
            //this.getPurchaseInquirySelectbyIDNotInPurchaseOrderItems();
            let itemRowData = [];
            //let firstList = [];//this.state.firstList;
            this.state.firstList?.map((x, key) => {
                if (x.selectedRows === true) {
                    let tempSecondList = this.state.tempSecondList?.filter(ftr => ftr.idwoOrderRecv === x.idwoOrderRecv);
                    tempSecondList?.map((item, keyId) => {
                        let object = {
                            woRecvNo: x.woRecvNo,
                            drawingNo: item.drawingNo,
                            itemType: item.itemType,
                            idItem: item.idItem,
                            itemDetails: item.itemName,
                            woQuantity: item.pendingQty,
                            quantity: 0,
                            remarks: item.itemRemarks ? item.itemRemarks : "",
                            avlStock: item.avlStock ? item.avlStock : 0,
                            rate: item.rate ? item.rate : 0,
                            amount: item.amount ? item.amount : 0,
                            idwoOrderRecvItems: item.idwoOrderRecvItems,
                            idwoOrderRecv: item.idwoOrderRecv,
                            displaySerialNo: item.displaySerialNo,
                            keyId: keyId + 1,
                        };

                        itemRowData.push(object);
                    });
                }
            });
            this.setState({ itemRowData: itemRowData, open: false });
        })
    }

    back = () => {
        this.setState({ open: !this.state.open });
    }

    filterVendorRowData = (idwoOrderRecv) => {
        let arr = this.state.tempSecondList
        arr = arr.filter(x => x.idwoOrderRecv === idwoOrderRecv);
        let data = this.state.secondList;
        data = [];
        data = arr;
        this.setState({ secondList: data });
    }

    getStockTransfer = (idWOOrderRecv) => {
        if (idWOOrderRecv > 0) {
            let request = [
                idWOOrderRecv,
                this.state.stockObject.updateStatus,
                this.state.stockObject.idSalesInvoice,
            ];
            this.otherFormsServices.getStockTransfer(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent.workOrderRecvs;
                    // dynamicData.map(x => {
                    //     x.refNo = x?.woRecvNo
                    //     x.refDate = x.woRecvDate ? moment(x.woRecvDate).format('DD-MM-YYYY') : '';
                    // })
                    // let dynamicDataForItem = response.responseItem.responseContent.details;
                    // dynamicDataForItem.map(x => {
                    //     x.id = x.idwoOrderRecv
                    //     x.itemId = x.idwoOrderRecvItems;
                    // })
                    this.setState({
                        // challanRowData: dynamicData,
                        // tempVendorRowData: dynamicDataForItem,
                        // open: true
                    }, () => {
                        //this.filterVendorRowData(this.state.tempVendorRowData[0]?.woRecvNo)
                    });
                }
            })
        } else {
            this.SwalServices.Alert('Please select customer first')
        }
    }


    getTransactionStockTransferSelectbyId = (id) => {
        if (id > 0) {
            this.otherFormsServices.getTransactionStockTransferSelectbyId(id).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent[0][0];
                    let dynamicData2 = response.responseItem.responseContent[1];
                    let obj = this.state.stockObject;
                    obj.idStockTransfer = dynamicData.idStockTransfer;
                    obj.updateStatus = 1;
                    obj.idWOOrderRecv = dynamicData.idwoOrderRecv;
                    obj.idSalesInvoice = dynamicData.idSalesInvoice ? dynamicData.idSalesInvoice : 0;
                    obj.transferNo = dynamicData.stockTransferNo;
                    //obj.prefix = dynamicData.;
                    obj.transferDate = moment(dynamicData.stockTransferDate).format('YYYY-MM-DD');
                    obj.orderNo = dynamicData.orderNo;
                    obj.idPartyAccount = dynamicData.idCustomer;
                    obj.idTransfer = dynamicData.idCustomer;
                    //obj.transferList = dynamicData.;
                    obj.vehicleNo = dynamicData.vehicleNo;
                    //obj.address = dynamicData.address;
                    obj.ordDate = moment(dynamicData.orderDate).format('YYYY-MM-DD');;
                    obj.Transporter = dynamicData.transport;
                    obj.totalArticals = dynamicData.totalArticle;
                    obj.totalQuantity = dynamicData.totalQty;

                    let itemRowData = [];
                    dynamicData2?.map((item, key) => {
                        let object = {
                            //woRecvNo: x.woRecvNo,
                            drawingNo: item.drawingNo,
                            itemType: item.itemType,
                            idItem: item.idItem,
                            itemDetails: item.itemName,
                            woQuantity: item.woQuantity,
                            quantity: item.quantity,
                            remarks: item.itemRemarks ? item.itemRemarks : "",
                            avlStock: item.avlStock ? item.avlStock : 0,
                            rate: item.rate ? item.rate : 0,
                            amount: item.amount ? item.amount : 0,
                            idwoOrderRecvItems: item.idwoOrderRecvItems,
                            idwoOrderRecv: item.idwoOrderRecv,
                            displaySerialNo: item.displaySerialNo,
                            idMaterialRejection: item.idMaterialRejection,
                            idMaterialRejectionItems: item.idMaterialRejectionItems,
                            keyId: key + 1,
                        }
                        itemRowData.push(object);
                    });
                    this.setState({
                        stockObject: obj,
                        itemRowData: itemRowData,
                        isModalOpen: true
                    }, () => {
                        this.getPartyAccountSelectbyID()
                    });
                }
            })
        }
    }

    submit = () => {
        //const isValidAllFields = this.isValidAllFields();
        //if (isValidAllFields) {
        if (this.state.itemRowData.length === 0) {
            this.SwalServices.Alert("Please add items details");
        } else {
            let data = this.state.stockObject
            let request = {
                idStockTransfer: data.idStockTransfer,
                updateStatus: data.updateStatus,
                stockTransferNo: data.transferNo,
                stockTransferDate: data.transferDate,
                idCustomer: data.idTransfer,
                transporter: data.Transporter,
                orderNo: data.orderNo,
                orderDate: data.ordDate,
                vehicleNo: data.vehicleNo,
                totalQty: data.totalQuantity,  //data.totalQty,
                remarks: "",
                idCompany: this.state.idCompany,
                e_Date: data.e_Date ? data.e_Date : new Date().toISOString(),
                //e_IDUser: this.state.idUser,
                e_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                isUpdated: data.updateStatus === 1 ? true : false,
                updatedDate: data.updateStatus === 1 ? new Date().toISOString() : null,
                u_IDUser: data.updateStatus === 1 ? this.state.idUser : null,
                isDeleted: false,
                deletedDate: null,
                d_IDUser: null,
                totalArticle: data.totalArticals, // required (not nullable)
                idFinancialYear: data.idFinancialYear,
            };
            request.deleteItemsList = data.deleteItemsList;
            request.itemList = [];
            //let details = this.state.productObject;
            this.state.itemRowData?.map((item) => {
                let obj = {
                    //woRecvNo: x.woRecvNo,
                    drawingNo: item.drawingNo,
                    itemType: item.itemType,
                    idItem: item.idItem,
                    woQty: item.woQuantity,
                    itemDetails: item.itemName,
                    quantity: item.quantity,
                    avlStock: item.avlStock,
                    rate: item.rate,
                    amount: item.amount,
                    itemRemarks: item.remarks ? item.remarks : "",
                    idWo: 0,               // Required
                    idIntWo: 0,            // Required
                    displaySerialNo: item.displaySerialNo,
                    idWorkOrderRecv: item.idwoOrderRecv,
                    idWorkOrderRecvItems: item.idwoOrderRecvItems,
                    idMaterialRejection: item.idMaterialRejection ? item.idMaterialRejection : 0,
                    idMaterialRejectionItems: item.idMaterialRejectionItems ? item.idMaterialRejectionItems : 0,
                }
                request.itemList.push(obj);
            });
            this.otherFormsServices.submitStockTransferInsertUpdate(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let data = response.responseItem.responseContent;
                    if (data !== null) {
                        if (this.state.stockObject.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                                //receiptDetails: reset
                            }, () => {
                                this.resetFields();
                                this.procSelectAllRecordsSP();
                            });
                        }
                    }
                }
            });
        }
        //}
    }

    resetFields = () => {
        let obj = this.state.stockObject;
        obj.idStockTransfer = 0;
        obj.updateStatus = 1;
        obj.idWOOrderRecv = 0;
        obj.idSalesInvoice = 0;
        obj.transferNo = '';
        obj.prefix = "";
        obj.transferDate = '';
        obj.orderNo = "";
        obj.idPartyAccount = 0;
        obj.idTransfer = 0;
        //obj.transferList = [];
        obj.vehicleNo = '';
        obj.address = '';
        obj.ordDate = '';
        obj.Transporter = '';
        obj.totalArticals = '';
        obj.totalQuantity = ''
        obj.totalQty = 0;
        obj.e_Date = "";
        obj.idFinancialYear = 0;
        this.setState({ stockObject: obj, itemRowData: [] })
    }

    insertItem = () => {
        let data = this.state.itemObject;
        let itemRecord = [...this.state.itemRowData];
        let object = this.state.stockObject;
        object.totalQuantity = 0;
        itemRecord.map((x, key) => {
            if (x.keyId === data.keyId) {
                x.woQuantity = data.woQuantity;
                x.quantity = data.quantity;
                x.remarks = data.remarks;
                x.avlStock = data.avlStock;
                x.rate = data.rate;
                x.amount = data.amount;
                x.displaySerialNo = data.displaySerialNo;
            }
            object.totalQuantity = Number(object.totalQuantity) + Number(x.quantity);
        });
        this.setState({ itemRowData: itemRecord, isModalOpenForEditItem: false, stockObject: object }, () => {
            this.resetItemObject();
        })
    };

    resetItemObject = () => {
        let itemObject = this.state.itemObject;
        itemObject.woQuantity = 0;
        itemObject.quantity = 0;
        itemObject.remarks = "";
        itemObject.avlStock = 0;
        itemObject.rate = 0;
        itemObject.amount = 0;
        itemObject.displaySerialNo = "";
        this.setState({ itemObject: itemObject });
    }

    render() {
        return (
            <div className='stock-transfer'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <StockTransferPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            stockObject={this.state.stockObject}
                            handleChange={this.handleChange.bind(this)}
                            onGridReady={this.onGridReady.bind(this)}
                            close={this.closePopup.bind(this)}
                            submit={this.submit.bind(this)}
                            validState={this.state.validState}
                            itemRowData={this.state.itemRowData}
                            handleChangeForDropdown={this.handleChangeForDropdown.bind(this)}
                            addWorkOrder={this.addWorkOrder.bind(this)}
                            addProduct={this.addProduct.bind(this)}
                            back={this.back.bind(this)}
                            open={this.state.open}
                            firstList={this.state.firstList}
                            secondList={this.state.secondList}
                            handleCellClickfirstList={this.handleCellClickfirstList.bind(this)}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                            onSelectionChanged={this.onSelectionChanged.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Stock transfer</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                        <EditStockTransferItem
                            isModalOpen={this.state.isModalOpenForEditItem}
                            setOpenModel={this.setOpenModelForItem.bind(this)}
                            itemObject={this.state.itemObject}
                            //handleChange={this.handleChange.bind(this)}
                            close={this.setOpenModelForItem.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            //deleteItem={this.deleteItem.bind(this)}
                            handleChangeForChequeBookItem={this.handleChangeForChequeBookItem.bind(this)}
                        //validState={this.state.validState}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
